import { useAuth, useClerk } from '@clerk/react';
import { useEffect, type ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Route guard for authed pages. When a signed-out user hits a protected route
// we bounce them to the homepage (`/`) and open the Clerk sign-in modal over it
// as the backdrop, passing `forceRedirectUrl` so Clerk returns them to the page
// they were headed for once they sign in. Auth gating lives here alone, so a
// protected page never embeds its own <SignInButton>.
export default function RequireAuth({ children }: { children: ReactNode }) {
  const { isLoaded, isSignedIn } = useAuth();
  const { openSignIn } = useClerk();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoaded && !isSignedIn) {
      const returnTo = `${location.pathname}${location.search}${location.hash}`;
      void openSignIn({ forceRedirectUrl: returnTo });
      void navigate('/', { replace: true });
    }
  }, [isLoaded, isSignedIn, openSignIn, navigate, location]);

  if (!isLoaded || !isSignedIn) return null;
  return <>{children}</>;
}
